<template>
  <TextUpload
    :titleUpload="titleUpload"
    :subtitletUpload="subtitleUpload"
  />
  <CardUploadStatus
    v-for="(file, i) in personalDataFileDetails" :key="i"
    :isVisibleTitleCard="file.statusUpload != 'Success'"
    :titleCard="file.cardName"
    :isVisibleTitle="file.statusUpload == 'Success'"
    :titleFile="file.cardName"
    :subtitleFile="file.fileName"
    :isError="file.statusUpload == 'Error'"
    :isVisibleStatus="file.statusUpload != 'Success'"
    :status="'1'"
    :isVisibleIconFile="file.statusUpload != 'Success'"
    :isVisibleIconCheck="file.statusUpload == 'Success'"
    :isVisibleIconArrow="file.statusUpload == 'Error'"
    :isVisibleIconTrash="file.statusUpload != 'Error'"
    @try-again-click="handleTryAgainClick(file.routeNameComponent)"
  />
  <FooterButton :confirmData="confirmData" :isDisabled="isAnyUploadInProgress"/>
</template>

<script>
  import CardUploadStatus from '@/cadastro/components/CardUploadStatus.vue';
  import FooterButton from '../../components/FooterButton.vue';
  import TextUpload from '@/cadastro/components/TextUpload.vue';
  import { useStore } from '@/stores/cadastro';
  import { useRouter } from 'vue-router';
  import axios from 'axios';
  import Swal from 'sweetalert2';
  import { computed } from 'vue';

  export default {
    components: {
      CardUploadStatus,
      FooterButton,
      TextUpload
    },
    setup() {
      const store = useStore();
      const router = useRouter();

      const confirmData = async () => {
      const data = store.getPersonalData;
      data.registration_steps = {personal_data: true}
      const driverId = store.getDriverId

      try {
        const response = await axios.post(`/cadastro-motorista/update/${driverId}`, {
          data: data
        });
        if (response.data && response.data.id) {
          store.setDriverId(response.data.id);
        }
        Swal.fire({
          title: 'Dados enviados com sucesso!',
          text: 'Suas informações pessoais foram salvas, por favor informe o restante dos dados nos passos seguintes.',
          icon: 'success',
          allowOutsideClick: false,
          timer: 10000,
          timerProgressBar: true,
          showConfirmButton: true,
          confirmButtonText: 'Ok'
        }).then(() => {
          if (response.status == 200) {
            router.push({ name: 'StatusRegistration' });
          }
        });
      } catch (error) {
          console.error('Erro inesperado:', error);
          Swal.fire({
          title: 'Ops...',
          text: 'Erro inesperado, por favor tente novamente mais tarde.',
          icon: 'error',
          confirmButtonText: 'Ok'
          });
      }
    };

      const personalDataFiles = computed(() => store.getPersonalDataFile);
      const personalDataFileDetails = computed(() =>
        Object.values(personalDataFiles.value).map(file => ({
          cardName: file.cardName,
          fileName: file.fileName,
          routeNameComponent: file.routeNameComponent,
          statusUpload: file.statusUpload
        }))
      );

      const isAnyUploadInProgress = computed(() => 
        personalDataFileDetails.value.some(file => file.statusUpload !== 'Success')
      );

      const titleUpload = computed(() => {
        if (personalDataFileDetails.value.some(file => file.statusUpload === 'Error')) {
          return 'Upload com falha!';
        } else if (personalDataFileDetails.value.every(file => file.statusUpload === 'Success')) {
          return 'Temos sua foto!';
        } else {
          return 'Upload em andamento!';
        }
      });

      const subtitleUpload = computed(() => {
        if (personalDataFileDetails.value.some(file => file.statusUpload === 'Error')) {
          return 'O upload de seu comprovante falhou. Por favor, tente novamente.';
        } else if (personalDataFileDetails.value.every(file => file.statusUpload === 'Success')) {
          return 'Suas informações foram salvas com sucesso.';
        } else {
          return 'Há um upload em andamento. Por favor, aguarde.';
        }
      });

      return {
        confirmData,
        personalDataFileDetails,
        isAnyUploadInProgress,
        titleUpload,
        subtitleUpload,
        store
      };
    },
    methods: {
      handleTryAgainClick(routeNameComponent) {
        const correspondingRoute = this.getCorrespondingRoute(routeNameComponent);
        this.store.updatePersonalDataFile(routeNameComponent, false)
        this.$router.push({ name: correspondingRoute });
      },
      getCorrespondingRoute(routeNameComponent) {
        const routeMap = {
          'proof_of_address': 'UploadProof',
        };
        return routeMap[routeNameComponent];
      }
    }
  }
</script>
